(function() {
    document.addEventListener('DOMContentLoaded', () => {
        const btnOpen = document.getElementById('btn-show-coupons');
        const overlay = document.getElementById('coupons-modal-overlay');
        const btnClose = document.getElementById('close-coupons-modal');
        const unusedList = document.getElementById('coupons-unused-list');
        const usedList = document.getElementById('coupons-used-list');

        if (!btnOpen || !overlay) return;

        // Aplicar fuente general al modal para que coincida con el tema (OceanSans)
        overlay.style.fontFamily = 'OceanSans, Helvetica Neue, sans-serif';

        btnOpen.addEventListener('click', async () => {
            overlay.style.display = 'flex';
            unusedList.innerHTML = '<p style="font-size: 0.9rem; color: #666; margin:0;">Buscando cupones...</p>';
            usedList.innerHTML = '<p style="font-size: 0.9rem; color: #666; margin:0;">Buscando historial...</p>';

            const userId = window.GlobalClubUserId;
            if (!userId) {
                unusedList.innerHTML = '<p style="color: #e6107d; margin:0;">Error: Usuario no identificado.</p>';
                return;
            }

            try {
                // Llamado a la API (Endpoint de Reachout para canjes)
                const rootUrl = (window.ShopifyRoutes && window.ShopifyRoutes.root) ? window.ShopifyRoutes.root : '/';
                
                // NOTA: Asegúrate de que el backend de Apolo esté enrutando scope=redeems_list hacia el endpoint correcto: /redeems/list/{user_id}
                const url = `${rootUrl}apps/apolo-loyalty?scope=coupons&user_id=${userId}`;
                
                const response = await fetch(url);
                if (!response.ok) throw new Error("Error en la red");
                
                const data = await response.json();

                // === CORRECCIÓN CLAVE DE ESTRUCTURA ===
                // Según el JSON, la lista está en data.redeems
                let redeemsList = [];
                if (data && Array.isArray(data.redeems)) {
                    redeemsList = data.redeems;
                } else if (Array.isArray(data)) {
                    redeemsList = data; // Por si acaso a veces devuelve el array directo
                }

                // Obtener fecha actual para comparar vencimientos
                const now = new Date();

                // Filtrar según el flag "usage" y la fecha de expiración
                const unused = redeemsList.filter(item => {
                    if (!item) return false;
                    const isExpired = item.expiration_date ? new Date(item.expiration_date) < now : false;
                    return item.usage === false && !isExpired;
                });

                const used = redeemsList.filter(item => {
                    if (!item) return false;
                    const isExpired = item.expiration_date ? new Date(item.expiration_date) < now : false;
                    return item.usage === true || isExpired;
                });

                // 1. Pintar NO USADOS (Activos)
                unusedList.innerHTML = unused.length === 0 
                    ? '<p style="font-size: 0.95rem; color: #666; font-style: italic; margin:0;">No tienes cupones disponibles.</p>' 
                    : unused.map(item => {
                        const promoName = (item.promo && item.promo.name) ? item.promo.name : 'Cupón Especial';
                        
                        let expText = '';
                        if (item.expiration_date) {
                            const dateObj = new Date(item.expiration_date);
                            expText = `Vence: ${dateObj.toLocaleDateString('es-PE')}`;
                        }

                        return `
                        <div style="display: flex; justify-content: space-between; align-items: center; background: #fff; border: 1px solid #f4ccd8; padding: 15px; border-radius: 8px; margin-bottom: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.02);">
                            <div style="flex: 1; padding-right: 15px;">
                                <strong style="color: #e6107d; display: block; font-size: 1.2rem; letter-spacing: 1px; margin-bottom: 4px;">${item.code}</strong>
                                <span style="font-size: 0.85rem; color: #333; display: block; line-height: 1.2; font-weight: 600;">${promoName}</span>
                                <span style="font-size: 0.75rem; color: #888; display: block; margin-top: 4px;">${expText}</span>
                            </div>
                            <button onclick="copyCouponCode('${item.code}', this)" style="background: #e6107d; color: white; border: none; padding: 8px 15px; border-radius: 20px; cursor: pointer; font-size: 0.85rem; font-weight: bold; transition: all 0.2s ease; min-width: 80px;">Copiar</button>
                        </div>
                    `}).join('');

                // 2. Pintar USADOS Y VENCIDOS (Historial)
                usedList.innerHTML = used.length === 0 
                    ? '<p style="font-size: 0.95rem; color: #999; font-style: italic; margin:0;">Aún no tienes historial de cupones.</p>' 
                    : used.map(item => {
                        const promoName = (item.promo && item.promo.name) ? item.promo.name : 'Cupón';
                        
                        // Determinar si está en esta lista por estar usado o por estar vencido
                        const isExpired = item.expiration_date ? new Date(item.expiration_date) < now : false;
                        const statusBadge = item.usage ? 'Usado' : (isExpired ? 'Vencido' : 'No disponible');

                        return `
                        <div style="background: #fafafa; border: 1px solid #eee; padding: 12px; border-radius: 8px; margin-bottom: 10px;">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px;">
                                <strong style="color: #aaa; font-size: 1.1rem; text-decoration: line-through;">${item.code}</strong>
                                <span style="font-size: 0.7rem; background: #eee; color: #777; padding: 2px 6px; border-radius: 4px; font-weight: bold;">${statusBadge}</span>
                            </div>
                            <span style="font-size: 0.8rem; color: #999; display: block; line-height: 1.2;">${promoName}</span>
                        </div>
                    `}).join('');

            } catch (error) {
                console.error("Error al cargar cupones:", error);
                unusedList.innerHTML = '<p style="color: #e6107d; margin:0;">Hubo un problema al cargar los cupones. Por favor intenta de nuevo.</p>';
                usedList.innerHTML = '';
            }
        });

        // Eventos para cerrar el modal
        btnClose.addEventListener('click', () => overlay.style.display = 'none');
        overlay.addEventListener('click', (e) => { 
            if (e.target === overlay) overlay.style.display = 'none'; 
        });
    });
})();

// Función global mejorada para copiar con feedback visual en el botón
window.copyCouponCode = function(code, buttonElement) {
    navigator.clipboard.writeText(code).then(() => {
        const originalText = buttonElement.innerText;
        const originalBg = buttonElement.style.backgroundColor;
        
        buttonElement.innerText = '¡Copiado!';
        buttonElement.style.backgroundColor = '#4CAF50'; // Verde de éxito
        
        // Volver a la normalidad después de 2 segundos
        setTimeout(() => {
            buttonElement.innerText = originalText;
            buttonElement.style.backgroundColor = originalBg;
        }, 2000);
    }).catch(err => {
        console.error('Error al copiar:', err);
        alert('No se pudo copiar el código. Selecciónalo manualmente.');
    });
};